import { FileUploader } from "react-drag-drop-files";
import { useSelector, useDispatch } from 'react-redux'
import { CloudUploadOutlined } from '@ant-design/icons';
import DownloadIcon from '@mui/icons-material/Download';
import Tooltip from '@mui/material/Tooltip';
import Alert from '@mui/material/Alert';
import { useEffect } from 'react';
import { Upload } from 'antd';
import {
  setFile, getFilename, getStyle, getBizID, getObjective, getFileAlertShow, getFileAlertMessage, getFileAlertColor, setFileAlert
} from '../../libs/todoSlice'
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";

export default function ExcelImportPreRegister() {
  const dispatch = useDispatch()
  const fileNameStore = useSelector(getFilename)
  const style = useSelector(getStyle)
  const navigate = useNavigate()
  const params = useParams()

  const showAlert = useSelector(getFileAlertShow)
  const alertMessage = useSelector(getFileAlertMessage)
  const alertColor = useSelector(getFileAlertColor)
  const { Dragger } = Upload;
  useEffect(() => {
    if (showAlert) {
      setTimeout(() => {
        dispatch(setFileAlert({
          file_alert_show: false,
          file_alert_color: '',
          file_alert_message: '',
        }))
      }, 3000)
    }
  }, [showAlert]);
  const readFile = (info) => {
    return new Promise((resolve, reject) => {
      const xlsx = require('xlsx')
      if (info) {
        const reader = new FileReader();
        reader.readAsArrayBuffer(info);
        reader.onload = (e) => {
          const data = e.target.result;
          const workbook = xlsx.read(data, { type: "array" });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const json = xlsx.utils.sheet_to_json(worksheet);
          reader.json = json;
          resolve({ json: json, info: info })
        };
      } else {
        resolve({ json: [], info: info })
      }
    })
  }
  const onChange = async (e) => {
    const extension = e.name.split('.')?.[1]
    if (extension !== 'xlsx' && extension !== 'xls') {
      dispatch(setFileAlert({
        file_alert_show: true,
        file_alert_color: 'error',
        file_alert_message: 'ไฟล์ไม่ถูกต้อง',
      }))

      dispatch(setFile({
        file: [],
        filename: '',
        file_id: ''
      }))
    } else {
      const { json, info } = await readFile(e)
      await setStore(json, info)
    }
  }
  const objective = useSelector(getObjective)
  const checkCase = (json) => {
    return (
      (json[0].birth_date !== undefined ? json[0].birth_date.replaceAll('\r', '') === "วันเกิด (ปปปป/ดด/วว)\n*เว้นว่างใหเแพทย์กรอกข้อมูลเอง" : false) &&
      (json[0].cid !== undefined ? json[0].cid.replaceAll('\r', '') === "เลขประจำตัวประชาชน\n(Identification Card)\n*ไม่ต้องมีขีดกลาง (-) หรือเว้นวรรค" : false) &&
      (json[0].email !== undefined ? json[0].email.replaceAll('\r', '') === "อีเมล" : false) &&
      (json[0].employee_id !== undefined ? json[0].employee_id.replaceAll('\r', '') === "เลขที่ใบประกอบวิชาชีพเวชกรรม (เลข ว.)" : false) &&
      (json[0].index !== undefined ? json[0].index.replaceAll('\r', '') === "ลำดับที่" : false) &&
      (json[0].tel !== undefined ? json[0].tel.replaceAll('\r', '') === "โทรศัพท์มือถือ\n*ไม่ต้องมีขีดกลาง (-) หรือเว้นวรรค" : false) &&
      (json[0].organization !== undefined ? json[0].organization.replaceAll('\r', '') === "โรงพยาบาลที่สังกัด\n*ห้ามแก้ไขข้อมูล ให้ทำการคัดลอกและวางทุกบรรทัด" : false) &&
      (json[0].name_eng !== undefined ? json[0].name_eng.replaceAll('\r', '') === "ชื่อ\n(ภาษาอังกฤษ)" : false) &&
      (json[0].name_th !== undefined ? json[0].name_th.replaceAll('\r', '') === "ชื่อ\n(ภาษาไทย)" : false) &&
      (json[0].title_th !== undefined ? json[0].title_th.replaceAll('\r', '') === "คำนำหน้า" : false) &&
      (json[0].surname_eng !== undefined ? json[0].surname_eng.replaceAll('\r', '') === "นามสกุล\n(ภาษาอังกฤษ)" : false) &&
      (json[0].surname_th !== undefined ? json[0].surname_th.replaceAll('\r', '') === "นามสกุล\n(ภาษาไทย)" : false) &&
      (json[0].title_special_th !== undefined ? json[0].title_special_th.replaceAll('\r', '') === "คำนำหน้านาม" : false) &&
      (json[0].position !== undefined ? json[0].position.replaceAll('\r', '') === "ตำแหน่ง" : false)
    )
  }
  const business_id = useSelector(getBizID)
  const setStore = (json, info) => {
    // console.log('json :>> ', json);
    const checked_json = json.filter((_, i) => i >= 1)
    if (json[1] === undefined || json[1] === null) {
      dispatch(setFileAlert({
        file_alert_show: true,
        file_alert_color: 'error',
        file_alert_message: 'ไฟล์ไม่ถูกต้อง',
      }))
      dispatch(setFile({
        file: [],
        filename: '',
        file_id: ''
      }))
    } else {
      if (json.length > 502) {
        dispatch(setFileAlert({
          file_alert_show: true,
          file_alert_color: 'error',
          file_alert_message: 'อัพโหลดครั้งละไม่เกิน 500 ข้อมูล',
        }))
        dispatch(setFile({
          file: [],
          filename: '',
          file_id: ''
        }))
      } else if (checkCase(json)) {
        dispatch(setFileAlert({
          file_alert_show: true,
          file_alert_color: 'success',
          file_alert_message: 'สำเร็จ',
        }))
        // console.log('checked_json :>> ', checked_json);
        dispatch(setFile({
          file: checked_json,
          filename: info.name,
        }))
        let formData = new FormData()
        formData.append('business_id', business_id)
        formData.append('excel', info)
        axios({
          method: 'POST',
          url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/excel`,
          data: formData,
        }).then(({ data, status }) => {
          dispatch(setFile({
            file: checked_json,
            filename: info.name,
            file_id: data.data._id
          }))
        }, ({ response }) => {
          const { status } = response
          if (status === 401) {
            navigate(`/${params.prefix}`)
          }
        })
      } else {
        // message.error('ไฟล์ไม่ถูกต้อง')
        dispatch(setFileAlert({
          file_alert_show: true,
          file_alert_color: 'error',
          file_alert_message: 'ไฟล์ไม่ถูกต้อง',
        }))
        dispatch(setFile({
          file: [],
          filename: '',
          file_id: ''
        }))
      }
    }
  }

  const downloadForm = () => {
    if (objective.includes('One ID') && objective.includes('CA') && objective.includes('เลขที่หนังสือสัญญา')) {
      window.open('/files/templates/oneid-ca-contract.xlsx', '_blank');
    } else if (objective.includes('One ID') && objective.includes('CA')) {
      window.open('/files/templates/oneid-ca.xlsx', '_blank');
    } else if (objective.includes('One ID') && objective.includes('เลขที่หนังสือสัญญา')) {
      window.open('/files/templates/oneid-contract.xlsx', '_blank');
    } else if (/* objective.includes('One ID') && */ objective.includes('Pre-register')) {
      window.open('/files/templates/oneid-preregis.xlsx', '_blank');
    } else if (objective.includes('One ID')) {
      window.open('/files/templates/oneid.xlsx', '_blank');
    }
  }

  return (
    <>
      <span>แบบฟอร์มเพิ่มรายชื่อ :
        <button
          onClick={downloadForm}
          style={{
            border: 'none',
            background: 'none'
          }}>
          {objective.map(o => { if (o === 'เลขที่หนังสือสัญญา') { return 'contract' } else { return o } }).join('-').toLowerCase().replaceAll(' ', '-')}.xlsx &nbsp;
          <Tooltip title={<span style={{ fontSize: '14px' }} >ดาวน์โหลดแบบฟอร์ม</span>} placement="right" >
            <DownloadIcon style={{ color: 'black' }} />
          </Tooltip>

        </button>
      </span>
      <br />
      <Dragger
        style={{
          display: 'none'
        }}
        accept={['.xlsx', '.xls', '.csv'].join(',')}
        beforeUpload={() => false}
        maxCount={1}
      >
        <p className="ant-upload-drag-icon">
          <CloudUploadOutlined />
        </p>
        <p className="ant-upload-text">ลากและวางเอกสารที่นี่</p>
        <p className="ant-upload-hint">
          หรือเลือกไฟล์ เฉพาะไฟล์ .xls และ .xlsx เท่านั้น
        </p>
      </Dragger>

      <FileUploader
        handleChange={onChange}
        style={{
          width: '100%',
        }}
        name="file"
        types={['xlsx', 'xls', 'csv']}
        children={<>
          <Dragger
            onClick={() => false}
            openFileDialogOnClick={false}
          >
            <p className="ant-upload-drag-icon">
              <CloudUploadOutlined style={{ color: style.primary_color ?? '#053075', }} />
            </p>
            <p className="ant-upload-text">ลากและวางเอกสารที่นี่</p>
            <p className="ant-upload-hint">
              หรือเลือกไฟล์ เฉพาะไฟล์ .xls และ .xlsx เท่านั้น
            </p>
          </Dragger>

        </>
        }
      />
      <span
        style={{
          color: 'red',
          fontSize: '14px'
        }}
      >
        *กรุณาอัปโหลดครั้งละไม่เกิน 500 รายชื่อ
      </span><br />
      {fileNameStore ? <><strong>Filename:</strong> {fileNameStore}</> : ''}
      {showAlert &&
        <Alert
          onClose={() => {
            dispatch(setFileAlert({
              file_alert_show: false,
              file_alert_color: '',
              file_alert_message: '',
            }))
          }}
          severity={alertColor}
        >
          {alertMessage}
        </Alert>
      }
    </>
  )
}